import * as React from "react";
import { connect } from "react-redux";
import { Col, Form, Row, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import ModalForm from "@hocs/ModalForm";
import { ApplicationState } from "@reducers/index";
import { updateRequest, fetchItemRequest } from "@actions/ticket";
import { Ticket } from "@models/ticket";
import TextEditor from "@components/custom/TextEditor";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  ticket?: Ticket,
}

interface PropsFromDispatch {
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type TicketFormAllProps = PropsFromState & PropsFromDispatch


type TicketFormStateShape = {
  visible: boolean;
  title: string;
  id: string | null;
  body: string;
  response: string;
  admin_user: any;
  user: any;
};

const { Text } = Typography;

class TicketForm extends React.Component<TicketFormAllProps, TicketFormStateShape> {
  constructor(props) {
    super(props);
    const { ticket } = props;
    this.state = {
      visible: false,
      ...this.getStateFormProps(ticket)
    };
  }

  getStateFormProps = (ticket: Ticket | null) => {
    const obj = ticket || {};
    return {
      title: obj.title || "",
      body: obj.body || "",
      response: obj.response || "",
      id: obj.id,
      admin_user: obj.admin_user,
      user: obj.user
    };
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.ticket && !prevProps.ticket.is_fetched && this.props.ticket.is_fetched) {
      this.setState({
        ...this.getStateFormProps(this.props.ticket)
      })
    }
  }

  componentDidMount() {
    if (this.state.id) {
      this.props.fetchItemRequest({
        params: {
          id: this.state.id
        }
      })
    }
  }


  getValues = () => {
    let returnValues: any = {};
    this.props.form.setFieldsValue({});

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
          patch: true
        };
      }
    });

    return {
      payload: [{
        value: returnValues.response,
        path: "response",
        op: "replace",
        from: ""
      }],
      id: this.state.id ? this.state.id : null,
      patch: true
    };
  };


  render() {
    const colspan = {
      labelCol: {
        span: 2
      },
      wrapperCol: {
        span: 22
      }
    }
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        <Row>
          <Col span={24}>

            <Row style={{ marginTop: "15px" }}>

              <Col span={15}>
                <FormattedMessage id="app.title" defaultMessage={`Title`} />{": "}
                <Text strong>{this.state.title}</Text>
              </Col>

              <Col span={3}>
                {this.state.user.avatar && <img
                  src={`https://static.filmnet.ir/avatar/${this.state.user.avatar}`}
                  style={{ width: "70px", objectFit: "contain" }}
                />}
              </Col>

              <Col span={6} style={{ marginTop: "15px" }}>
                <FormattedMessage id="app.ticket_user_msisdn" />{" "}
                <Text strong>{this.state.user.msisdn}</Text>
                <br />
                {this.state?.user?.name && <FormattedMessage id="app.ticket_user_name" />}{" "}
                <Text strong>{this.state.user.name}{" "}{this.state.user.family}</Text>
              </Col>

            </Row>

            <div style={{ marginBottom: "25px" }}>
              <FormattedMessage id="app.body" defaultMessage={`Body`} />
              <br />
              <Text strong>{this.state.body}</Text>
              <br />
            </div>

            <Form.Item
              {...colspan}
              label={
                <FormattedMessage
                  id="app.response"
                  defaultMessage={`Description`}
                />
              }
            >
              {getFieldDecorator("response", {
                initialValue: this.state.response || "",
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.response_is_required"
                        defaultMessage={`response is required!`}
                      />
                    )
                  }
                ]
              })(<TextEditor text={this.state.response} />)}
            </Form.Item>

            {this.state?.admin_user && <FormattedMessage
              id="app.ticket_admin_user"
            />}{" "}
            <p style={{ display: "inline-block" }}>{this.state?.admin_user?.name}</p>

          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = ({ tickets }: ApplicationState) => ({
  loading: tickets.loading,
  errors: tickets.errors
});

const mapDispatchToProps = {
  updateRequest,
  fetchItemRequest
};

const WrappedTicketForm = Form.create({ name: "ticket-form" })(TicketForm);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalForm(WrappedTicketForm));
